import { render, staticRenderFns } from "./ReportColumnConfiguratorTemplate.vue?vue&type=template&id=6ac0d89a"
import script from "./ReportColumnConfiguratorTemplate.vue?vue&type=script&lang=js"
export * from "./ReportColumnConfiguratorTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports